import { render, staticRenderFns } from "./LightbulbEduCode.vue?vue&type=template&id=2a6ebdfe&scoped=true&"
import script from "./LightbulbEduCode.vue?vue&type=script&lang=js&"
export * from "./LightbulbEduCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ebdfe",
  null
  
)

export default component.exports